import { render } from "./ProsesKBLI.vue?vue&type=template&id=33398242"
import script from "./ProsesKBLI.vue?vue&type=script&lang=js"
export * from "./ProsesKBLI.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__